export default __webpack_public_path__ + "static/media/menorah1.a57e8bf2.jpg";